import React, {useContext, useEffect, useState} from 'react';
import {
    Button,
    Card,
    CardContent,
    CardMedia,
    Badge, Dialog, DialogActions, DialogContent, DialogTitle,
    Menu,
    MenuItem,
    Tooltip,
    Paper, ListItemIcon
} from "@mui/material";
import Grid from '@mui/material/Grid';
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import {useNavigate} from "react-router-dom";
import './lodging.css';

import lodgingHeaderImage from '../../../graphics/th-513411954.jpg';
import LodgingCard from "./LodgingCard";
import dayjs from "dayjs";

import Box from "@mui/material/Box";
import usePA_GlobalStore from "../../../Services/ZustandGlobalStore";
import IconButton from "@mui/material/IconButton";

import InfoLodging from "../../Dialogs/InfoLodging";
import {Stack} from "@mui/system";
import {PAContext} from "../../../Services/PAContext";
import Lodging from "../../../MasterEventObjects/Lodging";
import {createTimeTableForLodging} from "../../Helpers/EventTimeTableConversion";


function LodgingList(props){

    const navigate = useNavigate();

    const { PA_GlobalObject, set_PA_GlobalObject } = usePA_GlobalStore();

    const { sendSocketMessage } = useContext(PAContext);


    const [eventLodging, setEventLodging] = useState([]);

    const [viewType, setViewType] = useState(
        usePA_GlobalStore.getState().PA_GlobalObject.Planning.time_table?.dates?.length > 0 ?
            'dates'
            : usePA_GlobalStore.getState().PA_GlobalObject.Planning.time_table?.days?.length > 0 ?
                'days' : 'dates'); // Either 'dates' or 'days'
    const [eventHasDates, setEventHasDates] = useState(usePA_GlobalStore.getState().PA_GlobalObject.Planning.time_table?.dates?.length > 0);
    const [eventHasDays, setEventHasDays] = useState(usePA_GlobalStore.getState().PA_GlobalObject.Planning.time_table?.days?.length > 0);
    const [selectedDate, setSelectedDate] = useState("all"); // For selected date
    const [selectedDay, setSelectedDay] = useState("all"); // For selected day

    const [selectedLodgingForDates , setSelectedLodgingForDates ] = useState("");
    const [selectedLodgingForDays , setSelectedLodgingForDays ] = useState("");

    const handleToggleViewType = () => {
        console.log("handleToggleViewType : " + viewType);

        const planning = usePA_GlobalStore.getState().PA_GlobalObject.Planning;
        const eventDays = planning.time_table?.days || [];
        const eventDates = planning.time_table?.dates || [];

        if (viewType === 'dates') {
            console.log("Changing Chips to days...");

            if (selectedDate === 'all') {
                setSelectedDay('all'); // Show all meals if "all" was selected
            } else {
                // Find the corresponding day for the selected date
                const correspondingDay = eventDates.find(dateEntry => dateEntry.date === selectedDate);
                if (correspondingDay) {
                    const dayIndex = eventDates.indexOf(correspondingDay);
                    const correspondingDayKey = Object.keys(eventDays[dayIndex] || {})[0] || 'all';
                    setSelectedDay(correspondingDayKey);
                } else {
                    setSelectedDay('all'); // Fallback
                }
            }

            setViewType('days');

        } else if (viewType === 'days') {
            console.log("Changing Chips to dates...");

            if (selectedDay === 'all') {
                setSelectedDate('all'); // Show all meals if "all" was selected
            } else {
                // Find the corresponding date for the selected day
                const correspondingDayEntry = eventDays.find(dayEntry => Object.keys(dayEntry)[0] === selectedDay);
                if (correspondingDayEntry) {
                    const dayIndex = eventDays.indexOf(correspondingDayEntry);
                    const correspondingDate = eventDates[dayIndex]?.date || 'all';
                    setSelectedDate(correspondingDate);
                } else {
                    setSelectedDate('all'); // Fallback
                }
            }

            setViewType('dates');
        }
    };

    useEffect(() => {
        const currentLodging = usePA_GlobalStore.getState().PA_GlobalObject.Planning.lodging;
        if (currentLodging !== eventLodging) {
            setEventLodging(currentLodging);
            setEventHasDates(usePA_GlobalStore.getState().PA_GlobalObject.Planning.time_table?.dates?.length > 0);
            setEventHasDays(usePA_GlobalStore.getState().PA_GlobalObject.Planning.time_table?.days?.length > 0);
        }
    }, [PA_GlobalObject.Planning.lodging]);


    /*
        this is for the Menu list in the header
     */
    // Common attendee mapping logic
    const getAttendees = (excludeRole = 'planner') => {
        const all = usePA_GlobalStore.getState().PA_GlobalObject.Planning.attendees || [];
        return all
            .filter((att) => att.role !== excludeRole && att.role !== 'partial' && att.rsvp !== 'decline')
            .map((att) => ({
                id: att.id,
                cost: 0,
                is_business_expense: false,
                business_expense_amount: 0,
            }));
    };
    const [anchorLodgingListMenu, setAnchorLodgingListMenu] = useState(null);
    const handleLodgingListMenuOpenMenu = (event) => {
        setAnchorLodgingListMenu(event.currentTarget);
    };
    const handleLodgingListMenuClick = (event) => {
        const target = event.currentTarget;
        const dataId = target.getAttribute('data-id');

        handleLodgingListMenuClose();

        if (dataId === "new-entry"){

            const _new_lodg = new Lodging();

            _new_lodg.attendees = getAttendees('planner');

            const eventTT = usePA_GlobalStore.getState().PA_GlobalObject.Planning.time_table;
            if (eventTT?.dates?.length > 0) {
                _new_lodg.time_table = createTimeTableForLodging(eventTT.dates[0].date, eventTT.dates[eventTT.dates.length - 1].date, eventTT);
            }

            set_PA_GlobalObject(prev => ({
                Planning: { ...prev.Planning, lodging: [...prev.Planning.lodging, _new_lodg] }
            }));
            if (PA_GlobalObject.Planning.status !== 10) {
                sendSocketMessage({ action: "E_addEventLodging_v2", event_id: PA_GlobalObject.Planning.id, lodging: _new_lodg });
            }

        } else if (dataId === "from-pdf"){
            navigate('/Planner/Lodging/AddFromPDF');
        }
    };
    const handleLodgingListMenuClose = () => {
        setAnchorLodgingListMenu(null);
    };

    function handlePromptChangeClose() {
        props.setShowEventItemConfig(false);
    }

    function handleLodgingChipClick(_lodging_id){

    }

    const [lodgingToDelete, setLodgingToDelete] = useState(null);  // Holds the lodging to delete for confirmation dialog
    const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);  // Controls the confirmation dialog visibility
    const handleDeleteLodging = (lodgingId) => {
        // Remove the lodging with the given ID
        const updatedLodging = eventLodging.filter(lodging => lodging.id !== lodgingId);

        // You can call a function to persist this change or update parent state
        setEventLodging(updatedLodging);


        //this updates the lodging array at the Global level
        set_PA_GlobalObject((prev) => ({
            Planning: {
                ...prev.Planning, // Retain all existing fields in Planning
                lodging: updatedLodging, // Update only the title
            },
        }));

        //send to server
        if (PA_GlobalObject.Planning.status !== 10){

            const _sendString = {};
            _sendString.action = "E_deleteEventLodging_v2";
            _sendString.event_id = PA_GlobalObject.Planning.id;
            _sendString.lodging_id = lodgingId;

            sendSocketMessage(_sendString);

        }

        closeDeleteDialog();

    };
    const openDeleteDialog = (lodging) => {
        setLodgingToDelete(lodging);  // Set the lodging to be deleted
        setDeleteDialogOpen(true);  // Open the confirmation dialog
    };
    const closeDeleteDialog = () => {
        setLodgingToDelete(null);  // Reset the lodging to be deleted
        setDeleteDialogOpen(false);  // Close the confirmation dialog
    };


    const [isLodgingInfoDialogOpen, setLodgingInfoDialogOpen] = useState(false);


    return (
        <div className="lodging-list-container">

            {/* --- LODGING HEADER --- */}
            <Paper
                elevation={0}
                sx={{
                    p: 1.5,
                    background: 'rgba(255, 255, 255, 0.8)',
                    backdropFilter: 'blur(12px)',
                    border: '1px solid rgba(255, 255, 255, 0.6)',
                    boxShadow: '0 4px 24px -6px rgba(0,0,0,0.06)',
                    borderRadius: '12px 12px 0 0',
                }}
            >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                    {/* Title Area */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box sx={{
                            background: 'linear-gradient(135deg, #2563eb 0%, #3b82f6 100%)', // Blue gradient
                            p: 0.9,
                            borderRadius: '10px',
                            display: 'flex',
                            boxShadow: '0 4px 10px rgba(37, 99, 235, 0.3)'
                        }}>
                            <i className="icon-bed" style={{ color: 'white', fontSize: '18px' }} />
                        </Box>
                        <Box sx={{ minWidth: 0 }}>
                            <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b', fontSize: '1rem', letterSpacing: -0.4, whiteSpace: 'nowrap' }}>
                                Lodging
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                <i className="icon-map-marker" style={{ color: '#2563eb', fontSize: '10px' }} />
                                <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 700, fontSize: '0.65rem', letterSpacing: 0.1, whiteSpace: 'nowrap' }}>
                                    Accommodations
                                </Typography>
                            </Box>
                        </Box>
                    </Box>

                    {/* Controls Area */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>

                        {/* Segmented View Toggle (Dates/Days) */}
                        <Box sx={{
                            display: 'flex',
                            bgcolor: '#f1f5f9',
                            p: 0.5,
                            borderRadius: '10px',
                            border: '1px solid #e2e8f0'
                        }}>
                            <Box
                                onClick={viewType !== 'dates' ? handleToggleViewType : null}
                                sx={{
                                    px: 1.5, py: 0.3, borderRadius: '7px', cursor: 'pointer',
                                    bgcolor: viewType === 'dates' ? '#fff' : 'transparent',
                                    boxShadow: viewType === 'dates' ? '0 2px 4px rgba(0,0,0,0.05)' : 'none',
                                    transition: '0.2s',
                                    display: 'flex', alignItems: 'center'
                                }}
                            >
                                <Typography sx={{ fontSize: '10px', fontWeight: 800, color: viewType === 'dates' ? '#2563eb' : '#64748b' }}>DATES</Typography>
                            </Box>
                            <Box
                                onClick={viewType !== 'days' ? handleToggleViewType : null}
                                sx={{
                                    px: 1.5, py: 0.3, borderRadius: '7px', cursor: 'pointer',
                                    bgcolor: viewType === 'days' ? '#fff' : 'transparent',
                                    boxShadow: viewType === 'days' ? '0 2px 4px rgba(0,0,0,0.05)' : 'none',
                                    transition: '0.2s',
                                    display: 'flex', alignItems: 'center'
                                }}
                            >
                                <Typography sx={{ fontSize: '10px', fontWeight: 800, color: viewType === 'days' ? '#2563eb' : '#64748b' }}>DAYS</Typography>
                            </Box>
                        </Box>

                        {/* Add Button */}
                        <Tooltip title="Add Lodging">
                            <IconButton
                                onClick={handleLodgingListMenuOpenMenu}
                                sx={{
                                    bgcolor: '#1e293b',
                                    color: 'white',
                                    borderRadius: '12px',
                                    width: '38px',
                                    height: '38px',
                                    boxShadow: '0 4px 12px rgba(30, 41, 59, 0.25)',
                                    transition: '0.2s',
                                    '&:hover': {
                                        bgcolor: '#334155',
                                        transform: 'translateY(-1px)',
                                    }
                                }}
                            >
                                <i className="icon-plus" style={{ fontSize: '20px' }} />
                            </IconButton>
                        </Tooltip>

                        {/* Upgraded Lodging Menu */}
                        <Menu
                            anchorEl={anchorLodgingListMenu}
                            open={Boolean(anchorLodgingListMenu)}
                            onClose={handleLodgingListMenuClose}
                            PaperProps={{
                                sx: {
                                    width: '280px',
                                    borderRadius: '16px',
                                    mt: 1.5,
                                    boxShadow: '0px 15px 35px rgba(37, 99, 235, 0.15)',
                                    border: '1px solid #f1f3f5',
                                    p: 1
                                }
                            }}
                            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                        >
                            <Box sx={{ px: 2, py: 1, mb: 1, borderBottom: '1px solid #f1f3f5' }}>
                                <Typography sx={{ fontSize: '11px', fontWeight: 900, color: '#64748b', letterSpacing: 0.5 }}>
                                    STAY MANAGEMENT
                                </Typography>
                            </Box>

                            <MenuItem
                                data-id="new-entry"
                                onClick={handleLodgingListMenuClick}
                                sx={{
                                    borderRadius: '12px',
                                    py: 1.5,
                                    '&:hover': { bgcolor: '#eff6ff' }
                                }}
                            >
                                <ListItemIcon sx={{
                                    minWidth: '42px',
                                    height: '42px',
                                    bgcolor: '#dbeafe', // Light blue background
                                    borderRadius: '10px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mr: 2
                                }}>
                                    <i className="icon-bed" style={{ color: '#2563eb', fontSize: '20px' }} />
                                </ListItemIcon>

                                <ListItemText
                                    primary="Add New Lodging"
                                    secondary="Manually enter stay details"
                                    primaryTypographyProps={{ fontWeight: 800, fontSize: '14px', color: '#1e293b' }}
                                    secondaryTypographyProps={{ fontSize: '11px', fontWeight: 600, color: '#64748b' }}
                                />
                            </MenuItem>
                        </Menu>
                    </Box>
                </Box>
            </Paper>


            {/* --- LODGING TIMETABLE NAVIGATION --- */}
            <Box
                className="lodging-list-timetable-list-container"
                sx={{
                    display: 'flex',            // Use flexbox
                    flexDirection: 'row',       // Align children in a row
                    flexWrap: 'nowrap',         // CRITICAL: Prevents chips from jumping to the next line
                    overflow: 'auto',
                    gap: 1.5,                   // Consistent spacing between your new DateTabs
                    py: 2,                      // Padding for the "hover lift" and badges
                    px: 1,
                }}
            >
                {(() => {
                    const allLodgingCards = [];
                    const planning = usePA_GlobalStore.getState().PA_GlobalObject.Planning;
                    const timeTable = planning['time_table'] || {};

                    // 1. Map Existing Lodging into Cards
                    eventLodging?.forEach((lodging, index) => {
                        const isSelected = selectedLodgingForDates === lodging.id;
                        let labelContent;

                        if (viewType === 'dates' && lodging.time_table?.dates?.length > 0) {
                            const start = dayjs(lodging.time_table.dates[0].date);
                            const end = dayjs(lodging.time_table.dates[lodging.time_table.dates.length - 1].date);

                            labelContent = (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Box sx={{ textAlign: 'center' }}>
                                        <Typography sx={{ fontSize: '10px', fontWeight: 800, opacity: 0.8 }}>{start.format('ddd').toUpperCase()}</Typography>
                                        <Typography sx={{ fontSize: '14px', fontWeight: 900 }}>{start.format('D')}</Typography>
                                    </Box>
                                    <Typography sx={{ fontWeight: 900, opacity: 0.5 }}>-</Typography>
                                    <Box sx={{ textAlign: 'center' }}>
                                        <Typography sx={{ fontSize: '10px', fontWeight: 800, opacity: 0.8 }}>{end.format('ddd').toUpperCase()}</Typography>
                                        <Typography sx={{ fontSize: '14px', fontWeight: 900 }}>{end.format('D')}</Typography>
                                    </Box>
                                </Box>
                            );

                            allLodgingCards.push({
                                sortDate: start,
                                component: (
                                    <Box key={`lodging-${lodging.id}`} onClick={() => handleLodgingChipClick(lodging.id)} sx={{ cursor: 'pointer', transition: 'all 0.2s ease', '&:hover': { transform: 'translateY(-2px)' } }}>
                                        <Badge badgeContent={<i className="icon-check" style={{ fontSize: '8px' }} />}
                                               sx={{ '& .MuiBadge-badge': { bgcolor: '#22c55e', color: 'white', minWidth: '16px', height: '16px', border: '2px solid #fff' } }}>
                                            <Box sx={{
                                                minWidth: '100px', height: 50, borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', px: 2,
                                                background: isSelected ? 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)' : '#fff',
                                                color: isSelected ? '#fff' : '#1e293b',
                                                border: isSelected ? 'none' : '1px solid #bfdbfe',
                                                boxShadow: isSelected ? '0 4px 12px rgba(37, 99, 235, 0.3)' : 'none',
                                            }}>
                                                {labelContent}
                                            </Box>
                                        </Badge>
                                    </Box>
                                )
                            });
                        }
                        // Add Days View Logic for Lodging here if needed
                    });

                    // 2. Identify Gaps and add "Missing" placeholders
                    const allCoveredDates = eventLodging.flatMap(l => l.time_table?.dates?.map(d => d.date) || []);

                    if (viewType === 'dates' && timeTable.dates) {
                        timeTable.dates.forEach(eventDateObj => {
                            const dateStr = eventDateObj.date;
                            if (!allCoveredDates.includes(dateStr)) {
                                const djs = dayjs(dateStr);
                                allLodgingCards.push({
                                    sortDate: djs,
                                    component: (
                                        <Box key={`gap-${dateStr}`} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <Badge badgeContent={<i className="icon-warning" style={{ fontSize: '8px' }} />}
                                                   sx={{ '& .MuiBadge-badge': { bgcolor: '#ef4444', color: 'white', minWidth: '16px', height: '16px', border: '2px solid #fff' } }}>
                                                <Box sx={{
                                                    width: 45, height: 50, borderRadius: '12px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                                                    bgcolor: '#fff', border: '1px dashed #ef4444', transition: 'all 0.3s ease'
                                                }}>
                                                    <Typography sx={{ fontSize: '9px', fontWeight: 800, color: '#94a3b8' }}>{djs.format('ddd').toUpperCase()}</Typography>
                                                    <Typography sx={{ fontSize: '1.1rem', fontWeight: 900, color: '#ef4444' }}>{djs.format('D')}</Typography>
                                                </Box>
                                            </Badge>
                                            <Typography sx={{ fontSize: '8px', fontWeight: 900, color: '#ef4444', mt: 0.5 }}>GAP</Typography>
                                        </Box>
                                    )
                                });
                            }
                        });
                    }

                    // 3. Sort and Render
                    return allLodgingCards
                        .sort((a, b) => a.sortDate.diff(b.sortDate))
                        .map(item => item.component);
                })()}
            </Box>

            {/* show the list of lodgings */}
            <div className="lodging-list-items-container">

                {
                    eventLodging && eventLodging.length > 0 ? (
                        eventLodging
                            .sort((a, b) => {
                                const dateA = a?.time_table?.dates?.[0]?.date;
                                const dateB = b?.time_table?.dates?.[0]?.date;

                                if (dateA && dateB) {
                                    // If both have valid dates, sort by date
                                    return dayjs(dateA).diff(dayjs(dateB));
                                } else if (!dateA && !dateB) {
                                    // If both dates are undefined, sort by name
                                    return a.name.localeCompare(b.name);
                                } else {
                                    // If only one is undefined, move undefined dates to the beginning
                                    return dateA ? 1 : -1;
                                }
                            })
                            .map((lodgingDetails, index) => (

                                <Grid item key={lodgingDetails.id}
                                      sx={{
                                          display: 'block',
                                          marginBottom: '10px'
                                      }}
                                >

                                    <LodgingCard
                                        lodging={lodgingDetails}
                                        onDeleteLodging={() => openDeleteDialog(lodgingDetails)}
                                        _global_map_ref={props._global_map_ref}
                                    />

                                </Grid>

                            ))
                    ) : (
                        <Grid item xs={12}>
                            <Paper elevation={3} sx={{ borderRadius: '5px', overflow: 'hidden' }}>
                                <Card>
                                    <CardMedia
                                        sx={{ height: 200 }}
                                        image={lodgingHeaderImage}
                                        title="Your Home Away from Home"
                                    />

                                    <CardContent sx={{ padding: '24px' }}>
                                        {/* Title */}
                                        <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, color: '#00897b' }}>
                                            🏨 No Lodging Yet
                                        </Typography>

                                        {/* Subhead */}
                                        <Typography variant="body1" sx={{ color: 'text.secondary', mb: 3 }}>
                                            Comfort, cost sharing, and coordination — let’s get everyone settled in.
                                        </Typography>

                                        {/* Lodging Features */}
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                            {/* Centralized Management */}
                                            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                                                <i className="icon-home" style={{ fontSize: '24px', color: '#00897b' }} />
                                                <Box>
                                                    <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                                                        Centralized Management
                                                    </Typography>
                                                    <Typography variant="body2" color="text.secondary">
                                                        Add and manage all lodging details in one place for easy coordination.
                                                    </Typography>
                                                </Box>
                                            </Box>

                                            {/* Flexible Options */}
                                            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                                                <i className="icon-office" style={{ fontSize: '24px', color: '#5c6bc0' }} />
                                                <Box>
                                                    <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                                                        Flexible Options
                                                    </Typography>
                                                    <Typography variant="body2" color="text.secondary">
                                                        Hotels, Airbnbs, cabins, campgrounds — whatever fits your group best.
                                                    </Typography>
                                                </Box>
                                            </Box>

                                            {/* Attendee Assignments */}
                                            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                                                <i className="icon-group" style={{ fontSize: '24px', color: '#7e57c2' }} />
                                                <Box>
                                                    <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>Attendee Assignments
                                                    </Typography>
                                                    <Typography variant="body2" color="text.secondary">
                                                        Link each attendee to their room and manage check-in/check-out smoothly.
                                                    </Typography>
                                                </Box>
                                            </Box>

                                            {/* Split the Cost */}
                                            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                                                <i className="icon-split" style={{ fontSize: '24px', color: '#f57c00' }} />
                                                <Box>
                                                    <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                                                        Cost Splitting
                                                    </Typography>
                                                    <Typography variant="body2" color="text.secondary">
                                                        Enter the total cost and split it evenly — or assign custom amounts.
                                                    </Typography>
                                                </Box>
                                            </Box>

                                            {/* Business Expense */}
                                            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                                                <i className="icon-wallet" style={{ fontSize: '24px', color: '#37474f' }} />
                                                <Box>
                                                    <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                                                        Business Expense?
                                                    </Typography>
                                                    <Typography variant="body2" color="text.secondary">
                                                        Mark attendees whose costs need reimbursement — we'll track it for you.
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Box>

                                        {/* Call to Action */}
                                        <Box sx={{ mt: 4, textAlign: 'center' }}>
                                            <Typography variant="body2" sx={{ fontStyle: 'italic', color: '#616161' }}>
                                                Where you sleep matters — let’s find your stay.
                                            </Typography>
                                            <Typography
                                                variant="button"
                                                sx={{
                                                    mt: 2,
                                                    display: 'inline-block',
                                                    color: '#fff',
                                                    backgroundColor: '#00897b',
                                                    padding: '8px 16px',
                                                    borderRadius: '8px',
                                                    cursor: 'pointer',
                                                }}
                                                onClick={() => {
                                                    // Trigger add lodging action
                                                }}
                                            >
                                                ➕ Add Lodging Details
                                            </Typography>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Paper>
                        </Grid>

                    )

                }
            </div>

            {/* Confirmation Dialog */}
            <Dialog
                open={isDeleteDialogOpen}
                onClose={closeDeleteDialog}
                // Added maxWidth and fullWidth for better mobile and desktop display
                maxWidth="sm"
                // Optional: Add a class for custom styling if needed
                PaperProps={{ sx: { borderRadius: "20px" } }}
            >
                {/* Use a Box for the content to apply padding, alignment, and styling */}
                <Box sx={{ p: 4, textAlign: 'center' }}>
                    {/* Icon for the header */}
                    <Box
                        sx={{
                            display: 'inline-flex',
                            bgcolor: 'rgb(250,227,225)',
                            p: 2,
                            borderRadius: '50%',
                            mb: 2,
                        }}
                    >
                        <i className="icon-warning" style={{color: 'rgb(211, 47, 47)', fontSize: '40px'}}/>
                    </Box>

                    {/* Title */}
                    <DialogTitle
                        id="delete-modal-title"
                        variant="h4"
                        component="h2"
                        fontWeight="bold"
                        sx={{ color: 'text.primary', m: 0, p: 0 }}
                    >
                        A Moment of Caution
                    </DialogTitle>

                    {/* Body Text */}
                    <DialogContent sx={{ p: 0, '&:first-of-type': { pt: 0 } }}>
                        <Typography variant="body1" sx={{ mt: 2, color: 'text.secondary', lineHeight: 1.6 }}>
                            <Box component="span" sx={{ fontWeight: 'bold', color: 'error.dark' }}>Heads up!</Box> Deleting this lodging will remove it
                            <Box component="span" sx={{ fontWeight: 'bold', color: 'error.dark' }}> for everyone in the event</Box>, and this action
                            <Box component="span" sx={{ fontWeight: 'bold', color: 'error.dark' }}> cannot be undone</Box>.
                        </Typography>
                        <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary', lineHeight: 1.6 }}>
                            This may also impact any associated costs and receipts.
                            If an attendee no longer wants to attend this lodging, they can simply remove
                            themselves on the lodging's attendee tab without having to delete it for everyone.
                        </Typography>
                        <Typography variant="body1" sx={{ mt: 3, fontWeight: 'bold', color: 'text.primary' }}>
                            Are you sure you want to delete the lodging "{lodgingToDelete?.location?.name || lodgingToDelete?.name}"?
                        </Typography>
                    </DialogContent>

                    {/* Buttons */}
                    <DialogActions sx={{ p: 0, mt: 4, justifyContent: 'center' }}>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center">
                            <Button
                                onClick={closeDeleteDialog}
                                variant="contained"
                                sx={{
                                    color: 'text.primary',
                                    bgcolor: 'grey.300',
                                    '&:hover': {
                                        bgcolor: 'grey.400',
                                    },
                                    borderRadius: '10px',
                                    boxShadow: 3,
                                    flexGrow: 1,
                                }}
                            >
                                No, Keep It
                            </Button>
                            <Button
                                onClick={() => handleDeleteLodging(lodgingToDelete.id)}
                                variant="contained"
                                sx={{
                                    bgcolor: 'error.dark',
                                    '&:hover': {
                                        bgcolor: 'error.main',
                                    },
                                    borderRadius: '10px',
                                    boxShadow: 3,
                                    flexGrow: 1,
                                }}
                            >
                                Yes, Delete Lodging
                            </Button>
                        </Stack>
                    </DialogActions>
                </Box>
            </Dialog>

            <InfoLodging
                isOpen={isLodgingInfoDialogOpen}
                onClose={() => setLodgingInfoDialogOpen(false)}
            />
        </div>
    )

}

export default LodgingList;

